import { render, staticRenderFns } from "./MsgElementTip.vue?vue&type=template&id=64bd56d6&scoped=true"
import script from "./MsgElementTip.vue?vue&type=script&lang=js"
export * from "./MsgElementTip.vue?vue&type=script&lang=js"
import style0 from "./MsgElementTip.vue?vue&type=style&index=0&id=64bd56d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd56d6",
  null
  
)

export default component.exports